export default "__VITE_ASSET__3EBoUmU0__ 100w";